// extracted by mini-css-extract-plugin
export default {"customHeader":"Collpase_customHeader__Dokr7"};